module.exports = __webpack_public_path__ + "img/slider-15.0f62406a.jpg";